/**
 * The `message` a refused request answered with. `apiRequest` throws
 * `Error("<status>: <body>")` (queryClient.ts); this reads the JSON body's message,
 * or gives `fallback` when there is none.
 */
export function apiErrorMessage(error: unknown, fallback: string): string {
  const raw = String((error as Error | undefined)?.message ?? "").replace(/^\d+:\s*/, "");
  try {
    const message = JSON.parse(raw)?.message;
    return typeof message === "string" && message.trim() !== "" ? message : fallback;
  } catch {
    return fallback;
  }
}
